import { useMemo } from 'react';
import { useConfiguration } from '@/features/SettingsView/hooks/useConfiguration';
import { retentionStartDate } from '@/utils/retention';

export function useRetentionStartDate(): Date | undefined {
    const { configuration } = useConfiguration();
    const retentionDays = configuration?.dataRetentionDays;
    return useMemo(() => retentionStartDate(retentionDays), [retentionDays]);
}
